<template>
  <form
    :id="scopeId"
    :class="{'nx-active': active, 'nx-form--sidebar': sidebar}"
    :data-vv-scope="scope"
    class="nx-form"
    @submit="onSubmit"
  >
    <div class="nx-form-fieldset">
      <template v-for="fieldConfig in fieldsConfig">
        <nx-form-scope-field-generator
          :key="fieldConfig.key"
          :component="fieldConfig.component"
          :scope="scope"
          :label="fieldConfig.label"
          :name="fieldConfig.name"
          :validation="fieldConfig.validation"
          :value="value[fieldConfig.name]"
          :form-value="value"
          :disable-if="fieldConfig.params.disableIf"
          :disable-if-overwrite-value-with="fieldConfig.params.disableIfOverwriteValueWith"
          :required-if="fieldConfig.params.requiredIf"
          :required-for-publish="fieldConfig.params.requiredForPublish"
          :required-for-publish-if="fieldConfig.params.requiredForPublishIf"
          :required-if-empty="fieldConfig.params.requiredIfEmpty"
          :required-for-publish-if-empty="fieldConfig.params.requiredForPublishIfEmpty"
          :required-for-publish-message="fieldConfig.params.requiredForPublishMessage"
          :not-required-if="fieldConfig.params.notRequiredIf"
          :not-required-if-empty="fieldConfig.params.notRequiredIfEmpty"
          :required-if-any="fieldConfig.params.requiredIfAny"
          :required-if-all="fieldConfig.params.requiredIfAll"
          :empty-if="fieldConfig.params.emptyIf"
          :heading="fieldConfig.params.heading"
          :value-to-disclaimer-message="fieldConfig.params.valueToDisclaimerMessage"
          :disclaimer-on-modified="fieldConfig.params.disclaimerOnModified"
          :disclaimer-ignore-field-id="fieldConfig.params.disclaimerIgnoreFieldId"
          :trigger-population="fieldConfig.params.triggerPopulation"
          :use-populate-fields-cms-api-service="fieldConfig.params.usePopulateFieldsCmsApiService"
          :enable-if-permission-action="fieldConfig.params.enableIfPermissionAction"
          :enable-if-permission-action-entity="fieldConfig.params.enableIfPermissionActionEntity"
          :enable-if-permission-action-current-value="fieldConfig.params.enableIfPermissionCurrentValue"
          :entity="entity"
          :entity-id="entityId"
          :params="{ ...fieldConfig.params, ...$attrs }"
          @request-population="$emit('request-population', $event)"
          @trigger-population="$emit('trigger-population', { fieldConfig, ...$event })"
          @bcube-assistant="$emit('bcube-assistant', $event)"
        />
      </template>
      <slot />
    </div>
  </form>
</template>

<script>
import FormScope from '@/modules/form/FormScope';
import PrepareFieldsConfig from '@/modules/form/mixins/prepare-fields-config';
import uuid from 'uuid/v4';
import NxFormScopeFieldGenerator from '@/modules/form/FormScopeFieldGenerator';

export default {
  name: 'NxFormGeneratorScope',
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  components: { NxFormScopeFieldGenerator },
  extends: FormScope,
  mixins: [PrepareFieldsConfig],
  props: {
    entityId: {
      type: Number,
      required: false,
      default: null,
    },
    entity: {
      type: String,
      required: false,
      default: null,
    },
    config: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
    editorFieldsConfig: {
      type: Object,
      default: () => ({}),
    },
    hideHeading: Boolean,
    advancedEditor: {
      type: Boolean,
      default: false,
    },
    sidebar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fieldsConfig() {
      let fieldsConfig = this.config.fieldsConfig || this.config.fields || [];
      fieldsConfig = fieldsConfig.map((fieldConfig) => {
        const fieldDescription = this.editorFieldsConfig[fieldConfig.field] || fieldConfig || {};
        return this.prepareFieldConfig(fieldDescription, this.scopeId, this.scope);
      });

      // Editors without advanced/basic
      if (!this.advancedEditor) {
        return fieldsConfig;
      }

      return fieldsConfig
        .filter((fieldConfig) => {
          // Wizards and stuff
          if (!this.$getParentEditor) {
            return true;
          }

          if (this.$getParentEditor().state.advancedMode) {
            return true;
          }

          return fieldConfig.showInBasicEditor || false;
        });
    },
    heading() {
      if (this.hideHeading) {
        return false;
      }
      if (this.title) {
        return this.$t(`message.form.scopes.${this.normalizeLocaleString(this.title)}`);
      }
      if (this.scope) {
        return this.$t(`message.form.scopes.${this.normalizeLocaleString(this.scope)}`);
      }
      return null;
    },
    scopeId() {
      return `scope-${this.scope || uuid()}`;
    },
  },
  methods: {
    onSubmit(e) {
      if (this.$listeners && this.$listeners.submit) {
        this.$emit('submit', e);
      }
      e.preventDefault();
    },
  },
};
</script>
<style lang="stylus">
.nx-form.nx-form--sidebar {
  padding-bottom: 33vh;
}

.module-editor-sidebar {
  .nx-form-scope-card {
    .nx-form--sidebar {
      padding-bottom: 0;
    }
  }

  .nx-form-scope-card:last-of-type {
    .nx-form--sidebar {
      padding-bottom: 33vh;
    }
  }
}
</style>
